import { render, staticRenderFns } from "./ApprovalsListPage.vue?vue&type=template&id=7900c402"
import script from "./ApprovalsListPage.vue?vue&type=script&lang=js"
export * from "./ApprovalsListPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports